<script>
	import { route } from "./stores";
</script>

<div class="Intro">
	<img src="./img/logo-white.webp" alt="MyID" />
	<div>
		<!-- <p>Выберите способ авторизации:</p> -->
		<button class="button" on:click={() => ($route = "creds")}
			>Liveness Check</button
		>
		<button class="button white" on:click={() => ($route = "compare")}
			>Verification Check</button
		>
	</div>
</div>

<style>
	.Intro {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		padding: 1em;
		background: url("../img/bg.webp");
		background-size: cover;
	}
	.Intro div {
		display: flex;
		flex-direction: column;
		justify-content: center;
		max-width: 14em;
	}
	img {
		max-width: 50%;
		margin-top: 1em;
		margin-bottom: 1em;
		margin: 0 auto;
		margin-bottom: 4em;
	}
	.button {
		background: #d625ae44;
		border: none;
		border-radius: 4px;
		color: white;
		padding: 0.7em 1.5em;
		min-width: 10em;
		cursor: pointer;
	}
	.white {
		background: #ffffff44;
	}
	.Intro button {
		font-size: 1.2em;
		margin: 0.7em 0;
	}
	p {
		margin-top: 0;
	}
</style>
